import React from 'react'
import CustomAddForm from '../version-4/MasterForms/CustomAddForm'

function AddProductCatalouge({ state, setState }) {
  const { description, name } = state

  const inputField = [
    { label: 'Name', value: name, name: 'name' },
    { label: 'Description', value: description, name: 'description' },
    { label: 'Status', value: state.active, type: 'ACTIVE' },
    { label: 'Files', name: 'image', type: 'IMAGE', multiple: true },
    // { label: 'Retail Book', name: 'retailBook', type: 'IMAGE' },
    // { label: 'Price Book', name: 'priceBook', type: 'IMAGE' },
  ]

  return <CustomAddForm state={state} setState={setState} data={inputField} />
}

export default AddProductCatalouge
